<!-- ═══════════════ MODAL: TOKEN SELECTOR ═══════════════ -->
@if (state.showTokenModal()) {
<div class="modal-overlay" (click)="state.closeTokenModal()">
  <div class="modal-panel animate-slide-up" (click)="$event.stopPropagation()">
    <button (click)="state.closeTokenModal()"
      class="absolute top-5.5 right-5.5 text-text-dim hover:text-white transition-colors text-lg">✕</button>

    <h3 class="font-display font-black text-2xl text-white tracking-wide mb-1">Select an Asset</h3>
    <p class="text-[11.5px] text-text-dim uppercase tracking-wider font-semibold mb-5">Choose from verified assets</p>

    <!-- Search Field -->
    <div
      class="bg-black/45 border border-border-primary focus-within:border-gold/30 rounded-2xl p-3.5 flex items-center gap-3 mb-5 transition-all">
      <svg class="w-4.5 h-4.5 text-text-dim" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round"
          d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
      </svg>
      <input type="text" placeholder="Search by name or symbol..." [value]="state.tokenSearchQuery()"
        (input)="state.tokenSearchQuery.set($any($event.target).value)"
        class="bg-transparent text-white text-[13.5px] outline-none w-full placeholder-text-dim font-medium" />
    </div>

    <!-- Scrollable Asset items -->
    <div class="flex flex-col gap-1.5 max-h-64 overflow-y-auto pr-1">
      @for (token of state.filteredTokens(); track token.symbol) {
      <button type="button" (click)="state.selectToken(token)"
        class="flex items-center justify-between p-3 hover:bg-white/[0.03] rounded-xl text-left border border-transparent hover:border-border-primary transition-all">
        <div class="flex items-center gap-3">
          <div class="token-badge" [style.background]="token.color">
            @if (token.logoUrl) {
              <img [src]="token.logoUrl" class="w-full h-full rounded-full object-cover">
            } @else {
              <ng-container>{{ token.symbol.charAt(0) }}</ng-container>
            }
          </div>
          <div>
            <p class="font-extrabold text-[13.5px] text-white tracking-wide leading-none">{{ token.symbol }}</p>
            <p class="text-[10px] text-text-dim mt-1 font-medium">{{ token.name }}</p>
          </div>
        </div>
        <div class="text-right">
          <p class="text-[13.5px] font-bold text-white">${{ token.rate.toLocaleString('en-US', {
            minimumFractionDigits: 2, maximumFractionDigits: 4 }) }}</p>
          <p class="text-[10.5px] font-bold" [class.text-emerald-400]="token.change > 0"
            [class.text-rose-400]="token.change < 0">
            {{ token.change > 0 ? '+' : '' }}{{ token.change.toFixed(2) }}%</p>
        </div>
      </button>
      } @empty {
      <div class="text-center py-8 text-text-dim text-[12px] font-bold uppercase tracking-wider">No matching assets
        found.</div>
      }
    </div>
  </div>
</div>
}